export default "__VITE_ASSET__Ds4X91n9__"